import { fork, call, put, take } from 'redux-saga/effects';

import {
	DAILY_REPORT_REQUESTING,
	DAILY_REPORT_SUCCESS,
	DAILY_REPORT_ERROR,
	TOTAL_DAILY_REPORT,
	LOAD_TOTAL_REPORT,
} from '@/redux/ducks/dailyReport/types';
import { INIT_APP_ERROR } from '@/redux/ducks/init/types';
import Api from '@/data';
import { getObjValue } from '@/utils/helper';

// Get daily report
export function* dailyReportData(payload) {
	try {
		const response = yield call(Api.getdailyReportData, payload.payload);
		if (payload.payload.offset > 0) {
			yield put({
				type: TOTAL_DAILY_REPORT,
				data: getObjValue(response, 'data'),
			});
		} else {
			yield put({
				type: DAILY_REPORT_SUCCESS,
				data: getObjValue(response, 'data'),
			});
		}
	} catch (error) {
		if (error.status === 401) {
			yield put({ type: INIT_APP_ERROR, error: error.data });
		} else {
			yield put({ type: DAILY_REPORT_ERROR, error: error.data });
		}
	}
}

export function* getDailyReport() {
	while (true) {
		const { payload } = yield take(DAILY_REPORT_REQUESTING);
		yield call(dailyReportData, payload);
	}
}

export function* getTotalDailyReport() {
	while (true) {
		const { payload, requestType } = yield take(LOAD_TOTAL_REPORT);
		yield call(dailyReportData, payload, requestType);
	}
}

function* dailyReportSaga() {
	yield fork(getDailyReport);
	yield fork(getTotalDailyReport);
}

export default dailyReportSaga;
